import _ from 'lodash'
import { getLeftMenuData } from '@/services/menu'

export default {
  name: 'menu-left-vertical',
  props: {
    settings: Object,
    withDrawer: {
      type: Boolean,
      default: false,
    },
    userDetails: Object,
  },
  mounted() {
    this.setSelectedKeys()
  },
  data() {
    return {
      menuData: [],
      selectedKeys: [],
      openKeys: [],
      selectedMenu: undefined,
    }
  },
  watch: {
    $route() {
      this.setSelectedKeys()
    },
  },
  methods: {
    setSelectedKeys() {
      this.checkRouting()
      let pathname = this.$route.path
      const menuData = this.menuData.concat()
      const flattenItems = (items, key) =>
        items.reduce((flattenedItems, item) => {
          flattenedItems.push(item)
          if (Array.isArray(item[key])) {
            return flattenedItems.concat(flattenItems(item[key], key))
          }
          return flattenedItems
        }, [])

      let selectedItem
      do {
        selectedItem = _.find(flattenItems(menuData, 'children'), [
          'url',
          pathname,
        ])

        var path = pathname.split('/')
        path.splice(path.length - 1, 1)
        pathname = path.join('/')
      } while (selectedItem === undefined && pathname.length > 0)
      this.selectedMenu = selectedItem ? selectedItem.key : selectedItem
    },

    checkRouting() {
      const accessToken = JSON.parse(
        localStorage.getItem('okta-token-storage'),
      )
      if (accessToken && accessToken.accessToken.accessToken) {
        if (this.$route.path === '/unauthorized') {
          this.$router.push('/dashboard')
        }
        const user = JSON.parse(localStorage.getItem('userDetails'))
        if (user) {
          this.menuData = getLeftMenuData.filter(i =>
            i.roles.includes(user.role),
          )
          const valid = this.menuData.find(
            i => i.url && i.url.split('/')[1] === this.$route.path.split('/')[1],
          )
          if (!valid && this.$route.path.split('/')[1] !== 'releaseNotes') {
            this.$router.push('/dashboard')
          }
        }
      } else {
        this.$router.push('/unauthorized')
      }
    },
  },
}
